// @flow
import client from '../../client'

// API Endpoint
export const EMAIL_TAKEN = '/auth/users/email_availability/'

/**
 * Check is given email taken by someone
 * @param  {string} email
 * @return {Promise<bool>}
 */
export const emailTaken = (email: string): Promise<boolean> =>
  client.get(EMAIL_TAKEN, { query: { email } }).then(
    (res) => !res.available,
    () => true
  )

export default emailTaken
